import { render, staticRenderFns } from "./WinnerList.vue?vue&type=template&id=60991ce4&scoped=true&"
import script from "./WinnerList.vue?vue&type=script&lang=js&"
export * from "./WinnerList.vue?vue&type=script&lang=js&"
import style0 from "./WinnerList.vue?vue&type=style&index=0&id=60991ce4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60991ce4",
  null
  
)

component.options.__file = "WinnerList.vue"
export default component.exports